import { render, staticRenderFns } from "./Data3Chart.vue?vue&type=template&id=f40139b8&scoped=true&"
import script from "./Data3Chart.vue?vue&type=script&lang=js&"
export * from "./Data3Chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40139b8",
  null
  
)

export default component.exports